module.exports = __webpack_public_path__ + "img/hanchuang.3210dd3e.png";